export default __webpack_public_path__ + "static/media/remider.41fb9ea4.svg";